import React from 'react';
import styles from './TaskProgress.module.css';
import {STATES} from '../lib/PageConstants';

const SEGMENTS = [
    {key: 'DONE', state: STATES.DONE, label: 'Done'},
    {key: 'IN_PROGRESS', state: STATES.IN_PROGRESS, label: 'Doing'},
    {key: 'NOT_DONE', state: STATES.NOT_DONE, label: 'To do'},
];

// The bar + legend showing the Done/Doing/To do split for a set of tasks.
const TaskProgress = ({tasks}) => {
    const counts = SEGMENTS.map(({key}) => tasks.filter((t) => t.status === key).length);
    const label = `Progress: ${counts[0]} done, ${counts[1]} doing, ${counts[2]} to do`;

    return (
        <div className={styles.wrap}>
            <div role="img" aria-label={label} className={styles.bar}>
                {SEGMENTS.map(({key, state}, i) => counts[i] > 0 && (
                    <span key={key} className={styles.segment} style={{flexGrow: counts[i], background: state.colour}}/>
                ))}
            </div>
            <div className={styles.legend}>
                {SEGMENTS.map(({key, state, label: segLabel}, i) => (
                    <span key={key} className={styles.legendItem}>
                        <span className={styles.legendDot} style={{background: state.colour}}/>
                        {counts[i]} {segLabel}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default TaskProgress;
